import { IoPeopleCircleOutline } from "react-icons/io5";

const RefereeSectionComponent = () => {

  const textMute = () => {
    return "text-muted";
  };
  
  return(
    <div className="mt-3">
      <IoPeopleCircleOutline size={28} className={textMute()}/>
      <h4 className={textMute()} style={{display: "inline"}}>&nbsp;REFEREE</h4>
      <hr />
      <div className="row">
        <div className="col">
          <ol>
            <li>
              <p><strong>Stanley Ndagi</strong></p>
              <p>Senior Software Engineer</p>
              <p>CircleCI</p>
              <p>Tel No.: <span><strong>+254718154504</strong></span></p>
              <p>Email: ndagis@gmail.com</p>
            </li>
          </ol>
          <hr />
        </div>
        <div className="col">
          <ol>
            <li>
              <p><strong>John Macharia</strong></p>
              <p>Software Engineer in Test</p>
              <p>Safaricom PLC</p>
              <p>Tel No.: <span><strong>+25472098582</strong></span></p>
              <p>Email: machariajohn20@gmail.com</p>
            </li>
          </ol>
          <hr />
        </div>
      </div>        
    </div>
  );  
};
export default RefereeSectionComponent;